module.exports = {"420882100":"新市镇","420882101":"永兴镇","420882102":"曹武镇","420882103":"罗店镇","420882104":"宋河镇","420882105":"坪坝镇","420882106":"三阳镇","420882107":"绿林镇","420882108":"杨集镇","420882109":"孙桥镇","420882110":"石龙镇","420882111":"永漋镇","420882112":"雁门口镇","420882113":"钱场镇","420882170":"开发区（镇）","420882449":"温泉新区","420882450":"太子山","420882451":"罗汉寺","420882452":"长滩","420882453":"何集","420882455":"易家岭","420882456":"屈家岭经济开发区","420882598":"原种场镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420882.json
// module id = 1755
// module chunks = 0